import { useState } from "react";
import { useLocale } from "../state/i18n";

type PasswordInputProps = {
  id: string;
  value: string;
  onChange: (value: string) => void;
  autoComplete: "current-password" | "new-password";
  required?: boolean;
  minLength?: number;
  disabled?: boolean;
};

export function PasswordInput({
  id,
  value,
  onChange,
  autoComplete,
  required,
  minLength,
  disabled,
}: PasswordInputProps) {
  const { t } = useLocale();
  const [visible, setVisible] = useState(false);

  return (
    <div className="password-field">
      <input
        id={id}
        type={visible ? "text" : "password"}
        autoComplete={autoComplete}
        autoCapitalize="off"
        autoCorrect="off"
        spellCheck={false}
        value={value}
        minLength={minLength}
        required={required}
        disabled={disabled}
        onChange={(event) => onChange(event.target.value)}
      />
      <button
        type="button"
        className="password-field__toggle"
        aria-controls={id}
        aria-pressed={visible}
        disabled={disabled}
        onClick={() => setVisible((current) => !current)}
      >
        {visible ? t("password.hide") : t("password.show")}
      </button>
    </div>
  );
}
